import React from 'react';

import { Link } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Box, BoxProps, Typography, TypographyProps } from 'components/ui';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';
import { getDesignToken, primitive } from 'styles/constants';
export const DrinksTabLink = Link.withConfig<{ active?: boolean }>(p => ({
  flexGrow: 1,
  isUnderlined: false,
  margin: 0,
  fontFamily: 'body',
  textAlign: 'center',
  textTransform: 'none',
  maxWidth: 'full',
  borderBottomWidth: 2,
  paddingX: 2,
  justifyContent: 'center',
  alignItems: 'center',

  _focus: {
    borderBottomColor: {
      base: p.active ? getDesignToken('color-tertiary') : 'transparent',
      md: p.active ? primitive.$bbqBrown : 'transparent',
    },
  },

  borderBottomColor: p.active ? getDesignToken('color-tertiary') : 'transparent',
  _text: {
    marginBottom: {
      md: 0,
    },
  },
}));

export const DrinksTabLinkText = ({ active, ...props }: TypographyProps & { active?: boolean }) => {
  const isDesktop = useIsDesktopBreakpoint();

  return (
    <Typography
      color={getDesignToken('color-tertiary')}
      fontFamily={active ? 'heading' : 'body'}
      mt="$0"
      fontSize={isDesktop ? 'sm' : undefined}
      lineHeight={isDesktop ? 'md' : undefined}
      {...props}
    />
  );
};

export const DrinksTabsWrapper = ({ style, ...props }: BoxProps) => (
  <Box {...props} style={[styles.drinksTabsWrapper, style]} />
);

export const TabsContent = ({ style, ...props }: BoxProps) => {
  const isDesktop = useIsDesktopBreakpoint();

  return (
    <Box {...props} style={[styles.tabsContent, isDesktop && styles.tabsContentDesktop, style]} />
  );
};

const styles = StyleSheet.create({
  drinksTabsWrapper: {
    backgroundColor: 'transparent',
    flexDirection: 'row',
    height: 56,
    marginVertical: 2,
    paddingTop: 8,
    position: 'relative',
    width: '100%',
  },
  tabsContent: {
    marginTop: 24,
  },
  tabsContentDesktop: {
    marginTop: 32,
  },
});
